// define('EideBaillyLLP.SiteModuleExtension', [
define('SearchModules', [
	'SiteSearch.View',
	'SiteSearch.Button.View',

	'SearchModules.View',
], function (
	SiteSearchView,
	SiteSearchButtonView,

	SearchModulesView
) {
	'use strict';

	return {
		mountToApp: function mountToApp(application) {

      var layout = application.getComponent('Layout');

			if (layout) {
				layout.registerView('SiteSearchAnywhere', function () {
					return new SiteSearchView({ application: application });
				});

				layout.registerView('SiteSearch.Button.Anywhere', function () {
					return new SiteSearchButtonView({ application: application });
				});

				layout.registerView('SearchModule.View', function () {
					return new SearchModulesView({ application: application });
				});
			}


		},
	};
});
